module.exports = __webpack_public_path__ + "static/media/editorial-code.dc676bba.png";